## 경력 사항

### Onmydev (2021.3 - 2024.5)
> 허리 및 목 디스크 악화로 퇴사.

-  [리뷰에이드](https://www.onmydev.com/reviewaid/)<br/>
    <small>AI 기반 리뷰 관리 시스템</small>

    - **모노레포 환경 설계 및 유지보수**
        - 공통 컴포넌트/유틸리티/어플리케이션등를 효율적으로 재사용할 수 있도록 Yarn Berry 기반 monorepo 환경을 구축 및 관리함.
        - Yarn workspace를 활용하여 패키지 관리 및 의존성 관리를 최적화함.
        - CI/CD 파이프라인을 GitHub Actions로 구축하여 자동화된 배포 및 테스트 환경을 구현함.

    - **디자인 시스템 및 UI 컴포넌트 개발**
        - React + TypeScript 기반 자체 디자인 시스템을 설계/구현하고, Storybook으로 문서화.
        - CSS/SCSS 모듈을 활용해 서비스별 커스터마이징이 용이하도록 스타일링 체계화.

    - **위젯 라이브러리 개발 및 배포**
        - 다양한 웹 서비스에 손쉽게 삽입 가능한 위젯 라이브러리(별점, SNS, 리뷰게시판 등) 개발.
        - Webpack(v1) Vite(v2)로 다양한 포맷 빌드 및 배포 자동화.
        - injector 모듈 및 백오피스를 통해 외부 서비스에 위젯을 동적으로 삽입/제거/설정할 수 있도록 설계(카페24 등 쇼핑몰 환경 특화).
        - 위젯별로 완전한 독립성 보장, lazy loading, 번들 최적화 적용.

    - **데이터 관리 및 API 연동**
        - TanStack Query(react-query) 기반 데이터 패칭/캐싱/상태관리 체계화, 커스텀 훅으로 재사용성 극대화.
        - 쿼리 키 전략, prefetch, optimistic update, 에러/로딩 상태 명확화 등 실무 적용.
        - API 패키지 분리 및 점진적 프론트엔드 종속화, Swagger/Atlassian 문서 연동.

    - **백오피스/관리도구 개발**
        - 위젯 옵션/설정/스크립트 관리, 강제 활성화/비활성화, 에러 리포트 등 백오피스 기능 개발 및 유지보수.
        - 실시간 설정 반영, 멀티샵 지원, 관리자 편의성 개선.
        - 위젯별 에러 리포트 및 통계 대시보드 개발, 실시간 모니터링 및 알림 시스템 구축.

    - **협업 및 문서화**
        - 커밋 메시지 규칙 코드리뷰, README/주석/TODO 등 문서화 체계화.
        - 팀원 온보딩, 기술 공유, 문서 자동화 경험.
        - 단위 테스트 작성,
        - ESLint, Prettier, Husky 등으로 코드 품질 자동화 및 협업 문화 정착.

   - **사용 기술**
        - Frontend: Vanilla JS/TS, Webpack, Vite, React, TypeScript, TanStack Query, Recoil
        - Styling: CSS/SCSS Modules, post css, Storybook
        - Testing: Vitest, @testing-library/react, jest
        - Tooling: Yarn, Yarn workspace, GitHub Actions, Figma, Swagger, Jira, Husky, ESLint, Prettier
        - infrastructure: AWS S3, CloudFront, Route53, Lambda, heroku


-  [atsent](https://www.onmydev.com/atsent)<br/>
    <small>AI 기반 감성 분석 프로그램</small>

    - AI 모델을 활용한 감성 분석 및 데이터 시각화.
    - 대시보드 UI/UX 구현 및 자체 디자인시스템 구현
    - 데이터 시각화 라이브러리(D3.js, Chart.js 등) 활용.

    - 사용 기술
        - Frontend: React, Recoil, storybook
        - Styling: CSS/SCSS Modules, post css
        - Tooling: Yarn, Yarn workspace, GitHub Actions, Figma, Swagger, Jira, Husky, ESLint, Prettier
        - infrastructure: AWS S3, CloudFront, Route53

-  [Aergo Agora](https://voting.aergo.io/)<br/>
    <small>블록체인 거버넌스 플랫폼</small>
        - 모바일 QR 로그인 기능 개발

    - 사용 기술
        - React Native, Android SDK herajs

-  onmydev<br/>
    <small>MLOps</small>
        - MLOps 플랫폼 개발.
        - 피봇.

    - 사용기술
        - React, recoil, scss

### Blocko / Aergo (2020.6 - 2021.2)
> 투자 실패로 인한 회사 사정 악화 및 CTO의 창업 초기멤버 합류 제의로 퇴사.

-  [Aergo Agora](https://voting.aergo.io/gov_voting)<br/>
    <small>블록체인 거버넌스 플랫폼</small>
    - 기존의 플랫폼에 사내 자체 라이브러리 [herajs](https://github.com/aergoio/herajs)를 이용한 보팅기능 추가.
    - 사내 디자인 시스템 활용 및 추가 컴포넌트 개발.
    - 기존의 플랫폼과의 통합을 고려한 설계 및 구현.

    - 사용 기술
        - Frontend: Vue.js, Vuex, herajs
        - infrastructure: Aergo mainnet

- Bu bois gold<br/>
    <small> ERC-721 기반 금 거래 시스템</small>
    - 프론트엔드 시스템만 담당
    - 이전 개발자 퇴사로 인해 개발중이던 프로그램을 이어받아 개발 시작.
    - 도커에 같이 말아 들어가는 프론트엔드였기 때문에 빌드시 자동 암호화 하여 프론트/백에 주입 할 수 있도록 개발

    - 사용 기술
        - Frontend : React, Redux
        - bundler: Webpack

- [Aergo Hub](https://www.youtube.com/watch?v=dW5VUBdawa4&list=PLa0sEw2Z7kmglsFU4KSKq6s17gb8pcZVD&index=1)<br/>
    <small>PaaS</small>
    - 사내 디자인 시스템 및 사내 백엔드 API 명세(Swagger) 기반으로 전체 UI/UX 구성.
    - keycloak을 이용한 인증 및 권한 관리.
    - Kubernetes 기반의 애플리케이션 배포 워크플로우를 사용자가 직관적으로 조작할 수 있도록 설계.
    - 마이크로서비스 기반 화면 구조 설계 및 공통 컴포넌트 정리.
    - 내부 베타 대상 사용자 피드백 및 디자이너의 의견을 반영하여 인터페이스 반복 개선.
    - github에 글을 쓰면 자동으로 목록 작성 및 배포되는 블로그 시스템 개발.
    - CI/CD 파이프라인을 GitHub Actions로 구축하여 자동화된 배포 환경을 구현함.

    - 사용 기술
        - Frontend: Vue.js, Vuex, docusaurus
        - Styling: SCSS
        - Tooling: Webpack, GitHub Actions

### 인더코어비즈니스플랫폼 (2019.3 - 2019.10)
> 회사 사정 악화로 인한 퇴사

- Staybot <br/><small>호텔 챗봇 솔루션</small>
    - 챗봇 클라이언트 및 어드민 사이트 개발
    - jQuery 기반의 기존 챗봇 클라이언트를 React로 리팩토링. -> 선임 채용 후 vue로 개발.
    - Dialogflow API 연동 및 대화 흐름 관리.
    - 서버리스를 이용한 백엔드 개발 및 유지보수
    - 사용자 경험을 고려한 UI/UX 설계 및 구현.
    - 다양한 플랫폼(웹, 모바일)에서의 호환성 및 반응형 디자인 적용.
    - 사용 기술
      - Frontend: React, react-thunk, mobx, jQuery, Vue,
      - Backend: Node.js
      - Styling: CSS, Bootstrap
      - database: dynamoDB, S3
      - infrastructure: AWS S3, CloudFront, Route53, Lambda, Athena

-


### 비주얼샤워 (2018.11 - 2019.1)
> 아르바이트. 급여 미지급으로 인한 퇴사.
- 블루스톤<br/>
  <small>게임</small>
    - 인게임 이벤트 및 이벤트 API 개발 및 유지보수, 이벤트 페이지 개발.
    - 유저 게시판 유지보수

    - 사용기술
        - vanillaJS, jQuery, PHP, CodeIgniter, MySQL

-

### 투바이포랩 (2014.11 - 2015.1)
> 아르바이트. 폐업
- 키스스캔들<br/>
    <small>게임</small>
    - 기획 및 QA.
    - 게임 시나리오 편집 및 작성. 게임 시나리오 툴 개발, 이벤트 시나리오 작성

    - 사용기술
        - VBA

-